<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">

                <adminNavigation></adminNavigation>

                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.MANAGE_JOBS_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#"
                                                    :class="{ active: activeTab === 'published' }"
                                                    @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#"
                                                    :class="{ active: activeTab === 'unpublished' }"
                                                    @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="jobsSearchInput" type="text" placeholder="Search"
                                                v-model="searchedText"
                                                @keyup.enter="fetchJobs(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addNewJobBtn" class="add-btn-admin" :class="{ 'active': showAddForm }"
                                                @click="showAddForm = true, selectedJobs = [], selectAll = false, cancelEdit()">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_JOB_BUTTON }}
                                            </button>
                                        </div>
                                        <div class="admin-add-btn">
                                            <a class="add-btn-admin" id="addNewJobCategoryBtn"
                                                href="/authority/job-category">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_JOB_CATEGORY_BUTTON }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedJobs.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedJobs.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedJobs = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">{{
                                                    constants.DELETE_ALL_BUTTON }}</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>
                                    {{ constants.ADD_NEW_JOB_TEXT }}
                                </h2>
                                <div class="add-banner-image-box">
                                    <form id="addJobForm" @submit.prevent="submitForm">
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.JOB_TITLE_LABEL }}
                                            </label>
                                            <select class="admin-selectbox" id="jobTitleSelectBox"
                                                v-model="newJob.jobTitle">
                                                <option value="">Select Title</option>
                                                <option v-for="category in jobCategories" :key="category.id"
                                                    :value="category.title">
                                                    {{ category.title }}
                                                </option>
                                            </select>
                                            <div class="error-msg" v-if="!newJob.jobTitle">{{ errMsg }}</div>
                                        </div>



                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.JOB_DESCRIPTION_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Description" class="text-editer"
                                                id="jobDescriptionInput" :editor="editor"
                                                v-model="newJob.jobDescription" :config="editorConfig"></ckeditor>
                                            <div class="error-msg" v-if="!newJob.jobDescription">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.SHORT_DESCRIPTION_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Short Description" class="text-editer"
                                                id="shortDescriptionInput" :editor="editor"
                                                v-model="newJob.shortDescription" :config="editorConfig"></ckeditor>
                                            <!-- <div class="error-msg" v-if="!newJob.shortDescription">{{ errMsg }}</div> -->
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.BENEFITS_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Benefits" class="text-editer" id="jobBenefitInput"
                                                :editor="editor" v-model="newJob.benefits" :config="editorConfig">
                                            </ckeditor>
                                            <!-- <div class="error-msg" v-if="!newJob.benefits">{{ errMsg }}</div> -->
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.KEYS_AND_RESPONSIBILITY_ACTIVITIES_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Keys & Responsibility" class="text-editer"
                                                id="jobKeyResInput" :editor="editor"
                                                v-model="newJob.keyAndResponsibilities" :config="editorConfig">
                                            </ckeditor>
                                            <!-- <div class="error-msg" v-if="!newJob.keyAndResponsibilities">{{ errMsg }}
                                            </div> -->
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.JOB_REQUIREMENT_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Job Requirement" class="text-editer" id="jobReqInput"
                                                :editor="editor" v-model="newJob.jobRequirements"
                                                :config="editorConfig"></ckeditor>
                                            <!-- <div class="error-msg" v-if="!newJob.jobRequirements">{{ errMsg }}</div> -->
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.LOCATION_LABEL }}
                                            </label>
                                            <input id="jobLocationInput" type="text" placeholder="Enter the location"
                                                v-model="newJob.location" />
                                            <div class="error-msg" v-if="!newJob.location">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.DATE_LABEL }}
                                            </label>
                                            <div class="admin-date-input">
                                                <datepicker 
                                                    v-model="newJob.jobPostDate" id="jobDateInput" class="date-icon"
                                                    placeholder="Enter Date">
                                                </datepicker>
                                            </div>
                                            <div class="error-msg" v-if="!newJob.jobPostDate">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.REQUIRED_EXPERIENCE_IN_YEAR_LABEL }}
                                            </label>
                                            <div class="admin-custom-row box-row-2">

                                                <div class="admin-input-field">
                                                    <label>
                                                        {{ constants.FROM_LABEL }}
                                                    </label>
                                                    <input id="jobExpFromSelectBox" type="text" placeholder=""
                                                        v-model="newJob.requiredExperience.from" />
                                                    <div class="error-msg" v-if="!newJob.requiredExperience.from">{{
                                                        errMsg }}</div>
                                                </div>
                                                <div class="admin-input-field">
                                                    <label>
                                                        {{ constants.TO_LABEL }}
                                                    </label>
                                                    <input id="jobExpToSelectBox" type="text" placeholder=""
                                                        v-model="newJob.requiredExperience.to" />
                                                    <div class="error-msg" v-if="!newJob.requiredExperience.to">{{
                                                        errMsg }}</div>
                                                </div>
                                            </div>
                                        </div>



                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.IMAGE_LABEL }}
                                            </label>
                                            <div class="image-upload-input upload-banner-image">
                                                <div
                                                    :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                                                    <div class="file-input-box">
                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                            @click="clearUploadedImage(false)"></button>
                                                        <input id="addJobFileInput" type="file"
                                                            @change="handleFileUpload($event, false)"
                                                            accept="image/jpeg,image/jpg,image/png" />
                                                    </div>
                                                    <div class="image-upload-input-item-in" v-if="!imageUploaded">
                                                        <div class="image-upload-input-item-icon">
                                                            <img src="@/assets/images/admin-img/image-icon.svg"
                                                                alt="" />
                                                        </div>
                                                        <span>
                                                            {{ constants.ADD_IMAGE_LABEL }}
                                                        </span>
                                                    </div>
                                                    <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                                                        <img :src="imageUrl" alt="" class="mCS_img_loaded">
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div> -->
                                        </div>
                                        <div class="admin-input-field-submit">
                                            <button id="jobSubmitBtn" type="submit"
                                                class="admin-btn-outline-primary add-new-cancel" :disabled="isSubmitting">{{
                                                    constants.SUBMIT_BUTTON
                                                }}</button>
                                            <button id="jobCancleBtn" type="button"
                                                class="admin-btn-outline-secondary add-new-cancel"
                                                @click="resetForm">{{
                                                    constants.CANCEL_BUTTON }}</button>
                                        </div>


                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section admin-jobs-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editJobsData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>

                                            <div class="admin-item-image">
                                                {{ constants.IMAGE_LABEL }}
                                            </div>

                                            <div class="admin-item-job-title" @click="toggleSort('jobTitle')" style="cursor: pointer;">
                                                {{ constants.TITLE_LABEL }}
                                                <button v-if="sortBy === 'jobTitle' || sortBy === '-jobTitle'" class="sorting-btn" :class="{ 'sorted': sortBy === '-jobTitle' }"></button>
                                            </div>

                                            <div class="admin-item-job-experience" @click="toggleSort('requiredExperience')" style="cursor: pointer;">
                                                {{ constants.REQUIRED_EXPERIENCE_LABEL }}
                                                <button v-if="sortBy === 'requiredExperience' || sortBy === '-requiredExperience'" class="sorting-btn" :class="{ 'sorted': sortBy === '-requiredExperience' }"></button>
                                            </div>

                                            <div class="admin-item-job-benefits" @click="toggleSort('benefits')" style="cursor: pointer;">
                                                {{ constants.BENEFITS_LABEL }}
                                                <button v-if="sortBy === 'benefits' || sortBy === '-benefits'" class="sorting-btn" :class="{ 'sorted': sortBy === '-benefits' }"></button>
                                            </div>

                                            <div class="admin-item-job-res-act" @click="toggleSort('keyAndResponsibilities')" style="cursor: pointer;">
                                                {{ constants.KEYS_AND_RESPONSIBILITY_ACTIVITIES_LABEL }}
                                                <button v-if="sortBy === 'keyAndResponsibilities' || sortBy === '-keyAndResponsibilities'" class="sorting-btn" :class="{ 'sorted': sortBy === '-keyAndResponsibilities' }"></button>
                                            </div>

                                            <div class="admin-item-job-job-requirement" @click="toggleSort('jobRequirements')" style="cursor: pointer;">
                                                {{ constants.JOB_REQUIREMENT_LABEL }}
                                                <button v-if="sortBy === 'jobRequirements' || sortBy === '-jobRequirements'" class="sorting-btn" :class="{ 'sorted': sortBy === '-jobRequirements' }"></button>
                                            </div>
                                            <div class="admin-item-job-short-desc" @click="toggleSort('shortDescription')" style="cursor: pointer;">
                                                {{ constants.SHORT_DESCRIPTION_LABEL }}
                                                <button v-if="sortBy === 'shortDescription' || sortBy === '-shortDescription'" class="sorting-btn" :class="{ 'sorted': sortBy === '-shortDescription' }"></button>
                                            </div>
                                            <div class="admin-item-job-desc" @click="toggleSort('jobDescription')" style="cursor: pointer;">
                                                {{ constants.JOB_DESCRIPTION_LABEL }}
                                                <button v-if="sortBy === 'jobDescription' || sortBy === '-jobDescription'" class="sorting-btn" :class="{ 'sorted': sortBy === '-jobDescription' }"></button>
                                            </div>
                                            <div class="admin-item-job-location" @click="toggleSort('location')" style="cursor: pointer;">
                                                {{ constants.LOCATION_LABEL }}
                                                <button v-if="sortBy === 'location' || sortBy === '-location'" class="sorting-btn" :class="{ 'sorted': sortBy === '-location' }"></button>
                                            </div>
                                            <div class="admin-item-job-date" @click="toggleSort('jobPostDate')" style="cursor: pointer;">
                                                {{ constants.DATE_LABEL }}
                                                <button v-if="sortBy === 'jobPostDate' || sortBy === '-jobPostDate'" class="sorting-btn" :class="{ 'sorted': sortBy === '-jobPostDate' }"></button>
                                            </div>
                                            <div class="admin-item-actions">
                                                {{ constants.ACTIONS_LABEL }}
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>

                                    <div class="admin-item-list-btm">

                                        <div ref="sortableList">
                                        <div v-for="(job, index) in editJobsData" :key="job.id"
                                            :class="['admin-item-box', { 'show-edit-item': job.editing }]">
                                            <div class="admin-item-box-top">
                                                <div class="admin-item-list-row">
                                                    <div class="admin-item-checkbox">
                                                        <div class="admin-checkbox-input">
                                                            <input name="cssCheckbox" :id="'demo_opt_' + job.id"
                                                                type="checkbox" class="css-checkbox"
                                                                @change="toggleJobSelection(job.slug)"
                                                                :checked="selectedJobs.includes(job.slug)">
                                                            <label :for="'demo_opt_' + job.id"></label>
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-image">
                                                        <div class="sm-img">
                                                            <img :src="getCdnImageAddress(job.jobImage, `w_40,h_41/`)" alt="" />
                                                        </div>
                                                    </div>

                                                    <div class="admin-item-job-title text-limit">
                                                        {{ job.jobTitle }}
                                                    </div>

                                                    <div class="admin-item-job-experience ">
                                                        {{ job.requiredExperience.from }}-{{ job.requiredExperience.to
                                                        }} Years
                                                    </div>

                                                    <div class="admin-item-job-benefits text-limit">
                                                        {{ useStripHtml(job.benefits) }}
                                                    </div>

                                                    <div class="admin-item-job-res-act text-limit">
                                                        {{ useStripHtml(job.keyAndResponsibilities) }}
                                                    </div>

                                                    <div class="admin-item-job-job-requirement text-limit">
                                                        {{ useStripHtml(job.jobRequirements) }}
                                                    </div>
                                                    <div class="admin-item-job-short-desc text-limit">
                                                        {{ useStripHtml(job.shortDescription) }}
                                                    </div>
                                                    <div class="admin-item-job-desc text-limit">
                                                        {{ useStripHtml(job.jobDescription) }}
                                                    </div>
                                                    <div class="admin-item-job-location text-limit">
                                                        {{ job.location }}
                                                    </div>
                                                    <div class="admin-item-job-date">
                                                        <span v-b-tooltip.up :title="formatDate(job.jobPostDate)"
                                                            data-bs-toggle="tooltip">{{
                                                                formatDate(job.jobPostDate) }}</span>
                                                        <!-- {{ job.relativePostDate }} -->
                                                    </div>
                                                    <div class="admin-item-actions">
                                                        <ul class="admin-action-link">
                                                            <li><button id="jobPgEditBtn" class="editBtn"
                                                                    @click="editJob(index), showAddForm = false">{{
                                                                        constants.EDIT_BUTTON
                                                                    }}</button></li>
                                                            <li>
                                                                <button data-bs-toggle="modal" id="jobPgDeleteBtn"
                                                                    data-bs-target="#deletePop"
                                                                    @click="setDeleteMode('single', job.slug), showAddForm = false, cancelEdit()">
                                                                    {{ constants.DELETE_BUTTON }}
                                                                </button>
                                                            </li>

                                                            <li><button id="jobPgUnPublishBtn"
                                                                    class="primary-outline-btn" v-if="job.status === 1"
                                                                    @click="changeJobStatus(job.slug, 0)">
                                                                    {{ constants.UNPUBLISH_BUTTON }}
                                                                </button>
                                                                <button id="jobPgPublishBtn" class="primary-outline-btn"
                                                                    v-else-if="job.status === 0"
                                                                    @click="changeJobStatus(job.slug, 1)">
                                                                    {{ constants.PUBLISH_BUTTON }}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            <div class="admin-item-box-btm" v-if="job.editing">
                                                <div class="add-banner-image-section">
                                                    <h2>
                                                        {{ constants.EDIT_CLIENT_TEXT }}
                                                    </h2>
                                                    <div class="add-banner-image-box">
                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.JOB_TITLE_LABEL }}
                                                            </label>
                                                            <select class="admin-selectbox" id="jobTitleSelectBox"
                                                                v-model="editJobData.jobTitle">
                                                                <option value="">Select Title</option>
                                                                <option v-for="category in jobCategories"
                                                                    :key="category.id" :value="category.title">
                                                                    {{ category.title }}
                                                                </option>
                                                            </select>
                                                            <div class="error-msg" v-if="!editJobData.jobTitle">{{
                                                                errEditMsg }}</div>
                                                        </div>
                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.JOB_DESCRIPTION_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Description" id="jobDescriptionInput"
                                                                class="text-editer" :editor="editor"
                                                                v-model="editJobData.jobDescription"
                                                                :config="editorConfig">
                                                            </ckeditor>
                                                            <div class="error-msg" v-if="!editJobData.jobDescription">{{
                                                                errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.SHORT_DESCRIPTION_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Short Description"
                                                                id="ShortDescriptionInput" class="text-editer"
                                                                :editor="editor" v-model="editJobData.shortDescription"
                                                                :config="editorConfig">
                                                            </ckeditor>
                                                            <!-- <div class="error-msg" v-if="!editJobData.shortDescription">
                                                                {{ errEditMsg }}</div> -->
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.BENEFITS_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Description" id="jobBenefitInput"
                                                                class="text-editer" :editor="editor"
                                                                v-model="editJobData.benefits" :config="editorConfig">
                                                            </ckeditor>
                                                            <!-- <div class="error-msg" v-if="!editJobData.benefits">{{
                                                                errEditMsg }}</div> -->
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.KEYS_AND_RESPONSIBILITY_ACTIVITIES_LABEL }}
                                                            </label>

                                                            <ckeditor placeholder="Description" id="jobKeyResInput"
                                                                class="text-editer" :editor="editor"
                                                                v-model="editJobData.keyAndResponsibilities"
                                                                :config="editorConfig">
                                                            </ckeditor>
                                                            <!-- <div class="error-msg"
                                                                v-if="!editJobData.keyAndResponsibilities">{{ errEditMsg
                                                                }}
                                                            </div> -->

                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.JOB_REQUIREMENT_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Description" id="jobReqInput"
                                                                class="text-editer" :editor="editor"
                                                                v-model="editJobData.jobRequirements"
                                                                :config="editorConfig">
                                                            </ckeditor>
                                                            <!-- <div class="error-msg" v-if="!editJobData.jobRequirements">
                                                                {{ errEditMsg }}</div> -->
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.LOCATION_LABEL }}
                                                            </label>
                                                            <input id="jobLocationInput" type="text"
                                                                placeholder="Enter the location"
                                                                v-model="editJobData.location" />
                                                            <div class="error-msg" v-if="!editJobData.location">{{
                                                                errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.DATE_LABEL }}
                                                            </label>
                                                            <div class="admin-date-input">
                                                                <datepicker 
                                                                    v-model="editJobData.jobPostDate" id="jobDateInput"
                                                                    class="date-icon" placeholder="Enter Date">
                                                                </datepicker>
                                                            </div>
                                                            <div class="error-msg" v-if="!editJobData.jobPostDate">{{
                                                                errMsg }}</div>

                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.REQUIRED_EXPERIENCE_IN_YEAR_LABEL }}
                                                            </label>
                                                            <div class="admin-custom-row box-row-2">

                                                                <div class="admin-input-field">
                                                                    <label>
                                                                        {{ constants.FROM_LABEL }}
                                                                    </label>
                                                                    <input id="jobExpFromSelectBox" type="text"
                                                                        placeholder=""
                                                                        v-model="editJobData.requiredExperience.from" />
                                                                    <!-- <select class="admin-selectbox" id="jobExpFromSelectBox">
                                      <option>0</option>
                                    </select> -->
                                                                    <div class="error-msg"
                                                                        v-if="!editJobData.requiredExperience.from">{{
                                                                            errEditMsg }}</div>
                                                                </div>
                                                                <div class="admin-input-field">
                                                                    <label>
                                                                        {{ constants.TO_LABEL }}
                                                                    </label>
                                                                    <input id="jobExpToSelectBox" type="text"
                                                                        placeholder=""
                                                                        v-model="editJobData.requiredExperience.to" />
                                                                    <!-- <select class="admin-selectbox" id="jobExpToSelectBox">
                                      <option>10</option>
                                    </select> -->
                                                                    <div class="error-msg"
                                                                        v-if="!editJobData.requiredExperience.to">{{
                                                                            errEditMsg }}</div>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.IMAGE_LABEL }}
                                                            </label>
                                                            <div class="image-upload-input upload-banner-image">
                                                                <div class="image-upload-input-item uploaded-done">
                                                                    <div class="file-input-box">
                                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                                            @click="clearUploadedImage(true)"></button>
                                                                        <input id="editJobFileInput" type="file"
                                                                            @change="handleFileUpload($event, true)"
                                                                            accept="image/jpeg,image/jpg,image/png" />
                                                                    </div>
                                                                    <div class="image-upload-input-item-uploaded">
                                                                        <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="admin-input-field-submit">
                                                            <button id="jobSubmitBtn" class="admin-btn-outline-primary"
                                                                @click="submitEditForm(job.slug)">
                                                                {{ constants.SUBMIT_BUTTON }}
                                                            </button>
                                                            <button id="jobCancleBtn"
                                                                class="admin-btn-outline-secondary addNewCancel"
                                                                @click="cancelEdit">
                                                                {{ constants.CANCEL_BUTTON }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<script lang="ts">
import { defineComponent, ref, nextTick  } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import Datepicker from 'vue3-datepicker';
import SimpleBar from 'simplebar';
import moment from 'moment';
import { vBTooltip } from 'bootstrap-vue-3';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

type ExperienceRange = {
    from: string;
    to: string;
};

interface Job {
    id: number;
    jobTitle: string;
    jobDescription: string;
    shortDescription: string;
    benefits: string;
    keyAndResponsibilities: string;
    jobRequirements: string;
    location: string;
    requiredExperience: ExperienceRange;
    jobImage: string;
    status: number;
    slug: string;
    jobPostDate: string
    editing?: boolean;
    Created_at?: string;
    relativePostDate?: string;
    position: number; // Add position field
}

export default defineComponent({
    name: "Manage-Job",
    directives: {
        'b-tooltip': vBTooltip
    },
    data() {
        return {
            constants,
            tooltips: [] as Tooltip[],
            jobCategories: [] as any,
            errMsg: '',
            errEditMsg: '',
            editor: ClassicEditor,
            activeTab: 'all',
            imageSrc: '',
            searchTempVar: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            jobs: [] as Job[],
            editJobsData: [] as Job[],
            selectedJobs: [] as string[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
            },
            newJob: {
                jobTitle: '',
                jobDescription: '',
                shortDescription: '',
                benefits: '',
                keyAndResponsibilities: '',
                jobRequirements: '',
                location: '',
                requiredExperience: {
                    from: '',
                    to: ''
                },
                jobImage: '',
                jobPostDate: new Date()
            },
            editJobData: {
                jobTitle: '',
                jobDescription: '',
                shortDescription: '',
                benefits: '',
                keyAndResponsibilities: '',
                jobRequirements: '',
                location: '',
                requiredExperience: {
                    from: '',
                    to: ''
                },
                jobImage: '',
                jobPostDate: new Date(),
                slug: ''
            },
            jobToDelete: null as string | null,
            deleteMode: 'all' as 'all' | 'single',
            isSubmitting: false,
            isDragging: false,
            sortableInstance: null as Sortable | null,
            sortBy: '-position' as string,
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        disabledDatesObject() {
            return {
                predicate: (date: Date) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return date < today;
                }
            }
        }
    },
    components: {
        adminHeader,
        adminNavigation,
        Datepicker
    },
    created() {
        this.limit = getPaginationLimit("manageJob", 10);
        this.fetchCounts();
        this.fetchJobs();
        this.getJobCategories()
    },
    mounted() {


        const el = this.$refs.scrollWrapper as HTMLElement;
        if (el) {
            new SimpleBar(el);
        };
        this.initializeTooltips();


    },
    methods: {
        initializeTooltips() {
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach((element) => {
                const tooltip = new Tooltip(element); 
                this.tooltips.push(tooltip);
            });
        },
        formatDate(date: any) {
            const pastDate = moment.utc(date).local();
            const now = moment();
            const secondsDiff = now.diff(pastDate, 'seconds');
            const minutesDiff = now.diff(pastDate, 'minutes');
            const hoursDiff = now.diff(pastDate, 'hours');
            const daysDiff = now.diff(pastDate, 'days');
            const weeksDiff = Math.floor(daysDiff / 7);
            const monthsDiff = now.diff(pastDate, 'months');
            const yearsDiff = now.diff(pastDate, 'years');
            console.log(daysDiff);


            if (secondsDiff < 60) {
                return `${secondsDiff} second${secondsDiff !== 1 ? 's' : ''} ago`;
            } else if (minutesDiff < 60) {
                return `${minutesDiff} minute${minutesDiff !== 1 ? 's' : ''} ago`;
            } else if (hoursDiff < 24) {
                return `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} ago`;
            } else if (daysDiff < 7) {
                return `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago`;
            } else if (daysDiff < 30) {
                return `${weeksDiff} week${weeksDiff !== 1 ? 's' : ''} ago`; // 7–29 days
            } else if (daysDiff < 365) {
                return `${monthsDiff} month${monthsDiff !== 1 ? 's' : ''} ago`;
            } else {
                return `${yearsDiff} year${yearsDiff !== 1 ? 's' : ''} ago`;
            }
        },
        setDeleteMode(mode: any, jobSlug?: string) {
            this.deleteMode = mode;
            if (jobSlug !== undefined) {
                this.jobToDelete = jobSlug;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteJob();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedJobs = []
            }
        },

        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true
                        }
                    }
                };
            }
        },
        toggleJobSelection(jobSlug: string) {
            if (this.selectedJobs.includes(jobSlug)) {
                this.selectedJobs = this.selectedJobs.filter(id => id !== jobSlug);
            } else {
                this.selectedJobs.push(jobSlug);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedJobs = [];
                this.selectAll = false
            } else {
                this.selectedJobs = this.editJobsData.map(job => job.slug);
                this.selectAll = true
            }
        },
        async submitForm() {
        if (!this.newJob.jobTitle || !this.newJob.jobDescription
            || !this.newJob.location
            || !this.newJob.requiredExperience.from || !this.newJob.requiredExperience.to
        ) {
            this.errMsg = "All Fields Are Required";
            return;
        }

        this.isSubmitting = true;

        const formData = new FormData();
        formData.append('jobTitle', this.newJob.jobTitle);
        formData.append('jobDescription', this.newJob.jobDescription);
        formData.append('shortDescription', this.newJob.shortDescription);
        formData.append('benefits', this.newJob.benefits);
        const selectedDate = new Date(this.newJob.jobPostDate);
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        selectedDate.setHours(hours, minutes, seconds);
        formData.append('jobPostDate', selectedDate.toISOString());
        formData.append('jobRequirements', this.newJob.jobRequirements);
        formData.append('location', this.newJob.location);
        formData.append('keyAndResponsibilities', this.newJob.keyAndResponsibilities);
        formData.append('requiredExperience', JSON.stringify(this.newJob.requiredExperience));

        if (this.selectedFile) {
            formData.append('jobImage', this.selectedFile);
        }
        try {
            const response = await fetch(`${API_BASE_URL}/job/`, {
                method: 'POST',
                body: formData
            });
            await response.json();
            this.resetForm();
            await this.fetchCounts(); // Fetch counts first
            await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Then fetch jobs
            this.imageUploaded = false;
            Swal.fire({
                icon: 'success',
                title: 'Job Created Successfully!',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error submitting job:', error);
        } finally {
            this.isSubmitting = false;
        }
    },
    async deleteSelectedContacts() {
        try {
            await axios.delete(`${API_BASE_URL}/job/bulk_delete/`, { data: { ids: this.selectedJobs } });
            this.editJobsData = this.editJobsData.filter(job => !this.selectedJobs.includes(job.slug));
            this.selectedJobs = [];
            await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            if (this.editJobsData.length === 0 && this.currentPage > 1) {
                this.currentPage--;
                await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            }
            this.fetchCounts();
            this.selectAll = false;
        } catch (error) {
            console.error('Error deleting contacts:', error);
        }
    },
        async submitEditForm(jobSlug: string) {
        if (!this.editJobData.jobTitle || !this.editJobData.jobDescription
            || !this.editJobData.jobPostDate || !this.editJobData.location
            || !this.editJobData.requiredExperience.from || !this.editJobData.requiredExperience.to
        ) {
            this.errEditMsg = "All Fields Are Required";
            return;
        }
        const formData = new FormData();
        formData.append('jobTitle', this.editJobData.jobTitle);
        formData.append('jobDescription', this.editJobData.jobDescription);
        formData.append('shortDescription', this.editJobData.shortDescription);
        formData.append('benefits', this.editJobData.benefits);
        const selectedDate = new Date(this.editJobData.jobPostDate);
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        selectedDate.setHours(hours, minutes, seconds);
        formData.append('jobPostDate', selectedDate.toISOString());
        formData.append('jobRequirements', this.editJobData.jobRequirements);
        formData.append('location', this.editJobData.location);
        formData.append('keyAndResponsibilities', this.editJobData.keyAndResponsibilities);
        formData.append('requiredExperience', JSON.stringify(this.editJobData.requiredExperience));
        if(this.selectedEditFile) formData.append('jobImage', this.selectedEditFile);
        // else formData.append('jobImage', '');

        try {
            await axios.patch(`${API_BASE_URL}/job/${jobSlug}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            this.cancelEdit();
            this.editFormSubmitted = false;
            Swal.fire({
                icon: 'success',
                title: 'Job Updated Successfully!',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error updating job:', error);
        }
    },

        handleLimitChange() {
            setPaginationLimit("manageJob", this.limit);
            this.currentPage = 1;
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
            this.selectAll = false
            this.selectedJobs = [];
            this.fetchJobs(this.activeTab, this.limit);
        },
        // @ts-expect-error
        async fetchJobs(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy) {
        const effectiveLimit = limit ?? this.limit;

        let url = `${API_BASE_URL}/job/`;
        const params = new URLSearchParams();
        if (status === 'published') params.append('status', '1');
        else if (status === 'unpublished') params.append('status', '0');
        // Only reset limit and page for a new search
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        // Do not reset this.limit here to preserve user selection
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        // Do not reset this.limit here to preserve user selection
        this.searchTempVar = '';
    }
            params.append('limit', effectiveLimit.toString());
            params.append('skip', skip.toString());
        
        if (this.searchedText) {
            params.append('limit', effectiveLimit.toString());
            params.append('skip', skip.toString());
            params.append('searchedText', this.searchedText);
        }
        params.append('sort_by', sortBy);

        try {
            const response = await axios.get(`${url}?${params.toString()}`);
            this.editJobsData = response.data.map((job: { jobPostDate: moment.MomentInput }) => ({
                ...job,
                relativePostDate: moment(job.jobPostDate).fromNow(),
            }));
            this.totalPages = Math.ceil(this.counts[status] / effectiveLimit);
            this.setupSortable();
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    },
        async switchView(status: string) {
                this.currentPage = 1;
                this.activeTab = status;
                this.selectedJobs = [];
                this.selectAll = false;
                this.editFormSubmitted = false;
                await this.fetchJobs(status, this.limit, 0);
                if (status === 'published') {
                    this.totalPages = Math.ceil(this.counts.published / this.limit);
                } else if (status === 'unpublished') {
                    this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
                } else {
                    this.totalPages = Math.ceil(this.counts.all / this.limit);
                }
            },
        removeImage() {
            this.imageSrc = '';
            this.selectedFile = null;
            this.imageUploaded = false;
        },
        resetForm() {
            this.newJob = {
                jobTitle: '',
                jobDescription: '',
                shortDescription: '',
                benefits: '',
                keyAndResponsibilities: '',
                jobRequirements: '',
                location: '',
                requiredExperience: {
                    from: '',
                    to: ''
                },
                jobImage: '',
                jobPostDate: new Date()
            };
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
            this.errMsg = '';
            this.imageUploaded = false;
        },
        async fetchCounts(searchedText?: string) {
            try {
                const baseUrl = `${API_BASE_URL}/job/count/`;
                const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}${queryParam}0&status=1`),
                    axios.get(`${baseUrl}${queryParam}1`),
                    axios.get(`${baseUrl}${queryParam}0`)
                ]);

                this.counts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };

                if (this.activeTab in this.counts) {
                    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit); 
                } else {
                    console.error(`Invalid active tab: ${this.activeTab}`);
                }
            } catch (error) {
                console.error('Error fetching job counts:', error);
            }
        },


        editJob(index: number) {
            this.editJobsData.forEach((job, i) => {
                job.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedJob = this.editJobsData[index];
            const requiredExperience = selectedJob.requiredExperience || { from: 0, to: 0 };
            const jobPostDate = typeof selectedJob.jobPostDate === 'string'
                ? new Date(selectedJob.jobPostDate)
                : selectedJob.jobPostDate;
            this.editJobData = {
                jobTitle: selectedJob.jobTitle,
                jobDescription: selectedJob.jobDescription,
                shortDescription: selectedJob.shortDescription,
                benefits: selectedJob.benefits,
                keyAndResponsibilities: selectedJob.keyAndResponsibilities,
                jobRequirements: selectedJob.jobRequirements,
                location: selectedJob.location,
                requiredExperience: selectedJob.requiredExperience,
                jobPostDate: jobPostDate,
                jobImage: selectedJob.jobImage || '',
                slug: selectedJob.slug  // Store slug for PATCH URL
            };
            
            
            this.editimageSrc = selectedJob.jobImage
            ? this.getCdnImageAddress(selectedJob.jobImage, 'w_200,h_100/')
            : '';



            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', true);
            }
        },


        cancelEdit() {
            this.editJobsData.forEach((job) => {
                job.editing = false;
            });
            this.editJobData = {
                jobTitle: '',
                jobDescription: '',
                shortDescription: '',
                benefits: '',
                keyAndResponsibilities: '',
                jobRequirements: '',
                location: '',
                requiredExperience: {
                    from: '',
                    to: ''
                },
                jobImage: '',
                jobPostDate: new Date(),
                slug: ''
            };
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.editimageSrc = '';
            this.errEditMsg = '';
            // Re-enable SortableJS after canceling edit
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false);
            }
        },

        async deleteJob() {
        try {
            await axios.delete(`${API_BASE_URL}/job/${this.jobToDelete}/`);
            await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            this.fetchCounts();
            (this.$refs.dummyButton as HTMLElement).click();
        } catch (error) {
            console.error('Error deleting job:', error);
        }
    },

    async changeJobStatus(jobId: string, newStatus: number) {
        try {
            const formData = new FormData();
            formData.append('status', newStatus.toString());

            await axios.patch(`${API_BASE_URL}/job/${jobId}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            if (this.editJobsData.length === 0 && this.currentPage > 1) {
                this.currentPage--;
                await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
            }
            this.fetchCounts();
        } catch (error) {
            console.error('Error updating job status:', error);
        }
    },
        async getJobCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/jobcategory/?status=1`);
                this.jobCategories = response.data;
            } catch (error) {
                console.error('Error fetching job categories:', error);
            }
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        setupSortable() {
        nextTick(() => {
            const sortableList = this.$refs.sortableList as HTMLElement;
            if (!sortableList) {
                console.error('Sortable list ref not found!');
                return;
            }

            if (this.sortableInstance) {
                this.sortableInstance.destroy();
            }

            this.sortableInstance = Sortable.create(sortableList, {
                animation: 150,
                draggable: '.admin-item-box',
                ghostClass: 'sortable-ghost',
                chosenClass: 'sortable-chosen',
                dragClass: 'sortable-drag',
                filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content', // Expanded filter
                preventOnFilter: true,
                disabled: this.editFormSubmitted,
                onStart: (evt: SortableEvent) => {
                    this.isDragging = true;
                    if (['jobTitle', '-jobTitle', 'shortDescription', '-shortDescription', 'jobDescription', '-jobDescription', 'benefits', '-benefits', 'keyAndResponsibilities', '-keyAndResponsibilities', 'jobRequirements', '-jobRequirements', 'location', '-location', 'requiredExperience', '-requiredExperience', 'jobPostDate', '-jobPostDate'].includes(this.sortBy)) {
                        evt.preventDefault();
                        Swal.fire({
                            icon: "warning",
                            title: "Cannot Drag",
                            text: "First remove sorting then you can be able to drag   it.",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        return false;
                    }
                },
                onEnd: async (evt: SortableEvent) => {
                    this.isDragging = false;
                    const oldIndex = evt.oldIndex!;
                    const newIndex = evt.newIndex!;

                    if (oldIndex === newIndex) return;

                    // Optimistically update local data for immediate feedback
                    const newJobsData = [...this.editJobsData];
                    const [movedItem] = newJobsData.splice(oldIndex, 1);
                    newJobsData.splice(newIndex, 0, movedItem);

                    const totalItems = newJobsData.length;
                    newJobsData.forEach((item, index) => {
                        item.position = totalItems - index;
                    });

                    // Update the reactive property
                    this.editJobsData = newJobsData;

                    // Prepare data for backend sync
                    const reorderedItems = newJobsData.map((item) => ({
                        id: item.id,
                        position: item.position,
                    }));

                    try {
        const response = await axios.post(`${API_BASE_URL}/job/reorder/`, {
            items: reorderedItems,
        });

        // Optionally use the response data instead of refetching
        this.editJobsData = response.data.data.map((job: { jobPostDate: moment.MomentInput }) => ({
            ...job,
            relativePostDate: moment(job.jobPostDate).fromNow(),
        }));

        Swal.fire({
            icon: 'success',
            title: 'Order Updated Successfully!',
            timer: 1500,
            showConfirmButton: false,
        });
    } catch (error) {
        console.error('Error updating order:', error);
        await this.fetchJobs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        Swal.fire({
            icon: 'error',
            title: 'Order Update Failed!',
            text: 'Reverted to last saved order.',
            showConfirmButton: false,
            timer: 1500,
        });
    }
                },
            });

            console.log('Sortable instance created:', this.sortableInstance);
        });
    },
    clearUploadedImage(isEdit: boolean) {
	if (isEdit) {
      this.editimageSrc = '';
      this.selectedEditFile = null;
      const fileInput = document.getElementById('editJobFileInput') as HTMLInputElement;
      if (fileInput) {
          fileInput.value = '';
      }
	} else {
        this.imageSrc = '';
        this.selectedFile = null;
        this.imageUploaded = false;
        const fileInput = document.getElementById('addJobFileInput') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }
},
toggleSort(field: string) {
            if (this.sortBy === field) {
                this.sortBy = `-${field}`; 
            } else if (this.sortBy === `-${field}`) {
                this.sortBy = '-position'; 
            } else {
                this.sortBy = field; 
            }
            this.fetchJobs(this.activeTab, this.limit, 0, this.sortBy);
        },
    },


});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>